/**
 * RISKS-V2
 * Represents the types and interfaces used in the risks feature.
 */
import { v4 as uuid } from "uuid"

export const PREVENTION_ACTION_ENTITY = "preventionAction"

//Repere de la mesure qui vient d'etre creee, porte par l'URL comme celui du risque : il vit le
//temps de la page, et PreventionActionChecklistItem l'anime partout ou la mesure est rendue.
export const NEWLY_ADDED_ACTION_PARAM = "addedAction"

export interface PreventionAction {
  //Id for the risk
  id: string

  //Attributes
  name: string
  description: string

  //Dates
  dateCreated: Date
  dateStartedPlanned: Date | null
  dateStarted: Date | null
  dateDone: Date | null
  datePlanned: Date | null

  //Add a relay to remove done
  refreshDelay: number | null
  cost: number | null
  financedBy: string | null
  uncheckedSteps: string[]

  //If null not active
  EstablishmentId: string | null

  //Relations
  //Sans risque, la mesure est une mesure RPS : de ses fonctions, ou de tout l'etablissement si populationIds est vide
  PhysicalRiskId: string | null
  populationIds: string[]
  UserId: string | null

  //Computed
  cRefreshDelayLabel: string | null
  cStatus: PreventionActionStatus
  cStatusLabel: string
  cRiskValueEffective: number | null
}

export type PreventionActionStatus = "todo" | "pending" | "done"

/**
 * Libelle oriente mesure ("Mesure réalisée" / "Mesure prévue"), a distinguer des libelles de
 * statut ("Terminé" / "Non commencé"). Une seule clef pour la pastille et l'etape Statut du wizard.
 */
export function getStatusLabelKey(isDone: boolean) {
  return isDone ? "prevention_action_measure_done" : "prevention_action_measure_todo"
}

//Une mesure sans risque est une mesure RPS
export function isRpsPreventionAction(action: Pick<PreventionAction, "PhysicalRiskId">) {
  return !action.PhysicalRiskId
}

//Une mesure RPS sans fonction concerne tout l'etablissement, donc chaque fonction
export function isRpsPreventionActionForPopulation(action: PreventionAction, populationId: string) {
  return !action.populationIds.length || action.populationIds.includes(populationId)
}

export const createEmptyPreventionAction = (overrides?: Partial<PreventionAction>): PreventionAction => {
  const defaultPreventionAction: PreventionAction = {
    id: uuid(),
    name: "",
    description: "",
    dateCreated: new Date(),
    dateStartedPlanned: new Date(),
    dateStarted: null,
    dateDone: null,
    datePlanned: new Date(new Date().setMonth(new Date().getMonth() + 1)),
    refreshDelay: null,
    cost: null,
    financedBy: null,
    uncheckedSteps: [],
    PhysicalRiskId: null,
    populationIds: [],
    UserId: null,
    EstablishmentId: null,

    //Computed
    cRefreshDelayLabel: null,
    cStatus: "todo",
    cStatusLabel: "",
    cRiskValueEffective: null
  }

  return {
    ...defaultPreventionAction,
    ...overrides
  }
}
